var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      class: ["message-search", { opened: _vm.searchOpened }],
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.searchMessages.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "input-wrapper" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchInput,
              expression: "searchInput",
            },
          ],
          ref: "searchInputField",
          staticClass: "input",
          attrs: {
            type: "search",
            name: "search",
            placeholder: "Search messages…",
          },
          domProps: { value: _vm.searchInput },
          on: {
            blur: _vm.closeSearch,
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              return _vm.closeSearch.apply(null, arguments)
            },
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchInput = $event.target.value
            },
          },
        }),
      ]),
      !_vm.onSearchPage
        ? _c("button", {
            staticClass: "search",
            attrs: {
              type: "button",
              "aria-label": "Search messages in this channel",
            },
            on: {
              mousedown: function ($event) {
                $event.preventDefault()
                return _vm.toggleSearch.apply(null, arguments)
              },
            },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }